<template>
  <div
    v-style:bg="backgroundColor"
    :class="{ 'py-6': backgroundColor }"
    data-test-id="collection-parallax"
  >
    <div :class="{ container: !isFullWidth }">
      <div v-if="parallax.type === 'twoCardParallax'" v-style="{ gap }" class="grid md:cols-2">
        <CmsParallax
          v-for="(item, i) in items"
          :key="i"
          :background-color="backgroundColor"
          :config="parallax?.config?.items?.[i]"
        >
          <component :is="`lazy-cms-${item.componentType}`" :content="item" />
        </CmsParallax>
      </div>
      <div v-if="parallax.type === 'galleryParallax'">
        <CmsParallaxGallery :config="parallax.config">
          <template #main>
            <component :is="`lazy-cms-${items[0].componentType}`" :content="items[0]" :full-height="true" />
          </template>
          <template v-for="(item, i) in items.slice(1)" :key="i">
            <component :is="`lazy-cms-${item.componentType}`" :content="item" />
          </template>
        </CmsParallaxGallery>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { CollectionParallax } from '#types/components/cms/collection'
import mappings from '#content/mappings'

const { content } = defineProps<{ content: CollectionParallax }>()

const { spacing } = useAppConfig().components.cms.collection
const { breakpoints } = useAppConfig().ds
const { backgroundColor = { sm: '#fff' }, parallax, isFullWidth } = content

const items = content.items.map((item) => ({
  ...item,
  componentType: resolveContentComponent(item, mappings)?.componentType
}))

// Create padding for each component
const gap = Object.keys(breakpoints)
  .reduce((acc, bp) => ({
    ...acc,
    ...(content.breakpoints[bp]?.slidePadding && {
      [bp]: `${(spacing[content.breakpoints[bp].slidePadding] || 0) * 2}rem`
    })
  }), {} as Responsive)
</script>
